import { useMemo } from "react";
import { useDocument } from "./DocumentComponentContext";
import { DOC_STATUS } from "./DocumentCompFunctions";
import { CheckIcon } from "@heroicons/react/24/outline";
import classNames from "classnames";

const DocumentScreening = () => {
  const { document } = useDocument();

  const isMobile = useMemo(() => window.innerWidth < 640, []);
  const hasRejectionReason = document.rejectionReason && !isMobile;
  const isRejectedStatus = DOC_STATUS.includes(document.documentStatus);
  if (hasRejectionReason && (document?.rejectionReason || "")?.length > 0) {
    return (
      <div className="absolute bottom-0 left-0 w-full text-[11px] px-2 py-1 bg-red-500 text-white rounded-b-lg text-center">
        {document.rejectionReason}
      </div>
    );
  }

  if (document.isAdditionalDocs && document?.documentStatus?.length > 0) {
    return (
      <div
        className={classNames(
          "absolute bottom-0 left-0 flex justify-between items-center w-full text-[11px] px-2 py-1 text-white rounded-b-lg",
          isRejectedStatus ? "bg-red-500" : "bg-green-500"
        )}
      >
        <span>{document.documentStatus}</span>
        {!isRejectedStatus && (
          <CheckIcon className="w-4 h-4 ml-1 flex-shrink-0" />
        )}
      </div>
    );
  }
  return (
    <div className="absolute bottom-0 right-0 h-6 w-6 text-white bg-green-500 flex items-center justify-center rounded-tl-lg rounded-br-lg">
      <CheckIcon className="w-4 h-4" />
    </div>
  );
};
export default DocumentScreening;
